//____ ANCHOR LINKS ANIMATIONS ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_smooth_scroll() {
    $(document).on('click', '[data-attr-scroll]', function (event) {
        event.preventDefault();

        var anchor = $(this).attr('data-attr-scroll');

        $('html,body').animate({
            scrollTop: $('#'+anchor).offset().top - ($('#main_header').height())
        }, 500);
    });
}